import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.25 4.25C9.66421 4.25 10 4.58579 10 5V8.75H13.75C14.1642 8.75 14.5 9.08579 14.5 9.5C14.5 9.91421 14.1642 10.25 13.75 10.25H10V14C10 14.4142 9.66421 14.75 9.25 14.75C8.83579 14.75 8.5 14.4142 8.5 14V10.25H4.75C4.33579 10.25 4 9.91421 4 9.5C4 9.08579 4.33579 8.75 4.75 8.75H8.5V5C8.5 4.58579 8.83579 4.25 9.25 4.25Z",
  fill: "#B82025"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}